// extracted by mini-css-extract-plugin
export default {"popover":"RequestProjectTasksPopover_popover__8T2Wi","wrapper":"RequestProjectTasksPopover_wrapper__Ew-p+"};